import React from 'react'
import "./footer.css"
import FooterLogo from "../../assets/images/LOGO2.png"
import { FaWhatsapp, FaInstagram, FaYoutube, FaFacebookF } from "react-icons/fa";
import { FaXTwitter, FaTiktok } from "react-icons/fa6";

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <div className="container-fluid containerSpacing">
                    <div className="row">
                        <div className="col-12">
                            <a className='footerLogo' href="/" data-aos-easing="ease-in-out" data-aos="fade-up">
                                <img src={FooterLogo} alt="Logo" />
                            </a>
                        </div>
                        <div className="col-12">
                            <div className="social-box" data-aos-easing="ease-in-out" data-aos="fade-right">
                                <ul>
                                    <li>
                                        <a href="">
                                            <FaWhatsapp />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaInstagram />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaXTwitter />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaYoutube />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaTiktok />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaFacebookF />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer